const formWrapper = document.querySelector('.wcl-form');

if (formWrapper) {
   const dataSelectsWrapper = formWrapper.querySelectorAll('.data-input');
   
   dataSelectsWrapper.forEach(function (dataInput) {
      const select = dataInput.querySelector('span');
      select.addEventListener("change", function () {
         select.classList.add('active');
      });
   });
}